import { createContext, useContext, useState, useEffect, useCallback, type ReactNode } from 'react'
import { fraudService } from '../modules/fraud/services/fraud'
import { authService } from '../modules/identity/services/auth'
import { UserRole } from '../types'

interface PendingNegConfsState {
  count: number
}

const PendingNegConfsContext = createContext<PendingNegConfsState>({ count: 0 })

const NEGCONF_ROLES: UserRole[] = [UserRole.INSURANCE_HEAD, UserRole.DEALER_PRINCIPAL]

export function PendingNegConfsProvider({ children }: { children: ReactNode }) {
  const [count, setCount] = useState(0)
  const user = authService.getCurrentUser()
  const isVisible = NEGCONF_ROLES.includes(user?.role as UserRole)

  const refresh = useCallback(() => {
    if (!isVisible) return
    fraudService.listNegativeConfirmations()
      .then(items => setCount(items.filter(n => n.customer_response === 'DISPUTED').length))
      .catch(() => {})
  }, [isVisible])

  useEffect(() => {
    refresh()
    if (!isVisible) return
    const interval = setInterval(refresh, 10_000)
    const onFocus = () => refresh()
    window.addEventListener('focus', onFocus)
    return () => {
      clearInterval(interval)
      window.removeEventListener('focus', onFocus)
    }
  }, [refresh, isVisible])

  return (
    <PendingNegConfsContext.Provider value={{ count }}>
      {children}
    </PendingNegConfsContext.Provider>
  )
}

export function usePendingNegConfs() {
  return useContext(PendingNegConfsContext)
}
